import React, { useState, useEffect, useRef } from "react";
import { Box, Backdrop, Fab, Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Dashborednav from "../Navbar/Dashborednav";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import { ProgramCard } from "./programs/program-card";
import { APPLICATION_DATA, TABS } from "../../constants/constants";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { useQuery } from "@tanstack/react-query";
import { fetchAcknowledgmentStatusService, fetchApplicationsService } from "../../services/users.services";
import ApplicationAccord from "./applications-accord";
import {
  generateApiKey,
  groupApplicationsByStatus,
} from "../../helpers/common.helpers";
import ExploreProgramsCard from "./explore-programs-card";
import { GoPlus } from "react-icons/go";
import { fetchCategoriesService } from "../../services/programs.service";
import ExploreProgramsModal from "./explore-programs";
import SecurityAdvisoryModal from "./acknoledgement-modal";
import ExpectationsModal from "../Dashboard/ExpectationsModal";
import { MdOutlineAssignment } from "react-icons/md";
import { ArrowRight } from "lucide-react";
import Layout from "../NewDashboard/Layout";
import NoEnrollmentsState from "../NewDashboard/components/NoEnrollmentsState";

const Myaccount = () => {
  const [user, setUser] = useState("");
  const [enrooll, setEnrooll] = useState("");
  const [open, setOpen] = useState(false);
  const [programs, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [isExploreModalOpen, setIsExploreModalOpen] = useState(false);
  const [appData, setAppData] = useState([...APPLICATION_DATA]);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get("tab") || "my-courses";
  const [isUserHasApplications, setIsUserHasApplications] = useState(false);
  const [sideTab, setSideTab] = useState(tabParam);
  const [isFaculty, setIsFaculty] = useState(false);
  const [acknowledgementModalOpen, setAcknowledgementModalOpen] = useState(true)
  const apiKey = generateApiKey();
  const currentDate = new Date('2025-10-15T00:00:00Z');
  const [expectationsModalOpen, setExpectationsModalOpen] = useState(false);
  const [showExpectationButton, setShowExpectationButton] = useState(false); // Add this line
  const [updateExpectationsCount, setExpecationsUpdateCount] = useState(true)
  const [enrolledPrograms, setEnrolledPrograms] = useState([]); // Raw API data
  const [enhancedPrograms, setEnhancedPrograms] = useState([]);
  const [isEnhancing, setIsEnhancing] = useState(false);
  const hasFetchedRef = useRef(false); // prevents fetchToken from re-running on tab changes
  const params = new URLSearchParams(location.search);
  const tab = params.get("tab");
  // const [programData, setProgramData] = useState([])

  // const studentDetailsSyncBatchIds = [
  //   103, 110, 112, 113, 115, 114, 116, 117, 118, 119, 120, 121, 122, 123, 124,
  //   125, 126, 127, 128, 129, 130, 131, 132, 133, 134,
  // ];
  const UNIVERSITY_FULL_NAMES = {
    'iitg': 'E&ICT Academy IIT Guwahati',
    'spjain': 'SP Jain School of Global Management',
    'iimv': 'IIM Visakhapatnam',
    'xlri': 'XLRI',
    'iimt': 'IIM Tiruchirappalli',
    'iitk': 'E&ICT Academy IIT Kanpur',
    'unknown': 'Independent Program'
  };

  const studentDetailsSyncBatchIds = [103, 110, 112, 116, 123];
  // const expectationDetailsBatchIds = [141, 142, 145, 148, 150, 153, 154];


  const fetchBatchInaugurationDate = async (category_id, program_id, batch_id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/profile/fetchBatchInaugurationDate`,
        { category_id: category_id, program_id: program_id, batch_id: batch_id },

      );

      console.log(response)

      if (response.data.status === 200 && response.data.data.length > 0) {
        return response.data.data[0].inauguration_date; // Returns the startdate of batch inauguration event
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  const shouldShowExpectationsModal = async (userId, enrollments) => {
    console.log("called")
    const cutoffDate = new Date('2025-10-15T00:00:00Z');
    const currentDate = new Date();

    // Filter enrollments with batch_date > Oct 15, 2025
    const eligibleEnrollments = enrollments.filter(enrol => {
      const batchDate = new Date(enrol.batch_date);
      return batchDate > cutoffDate;
    });

    console.log("Eligible enrollments:", eligibleEnrollments);

    if (eligibleEnrollments.length === 0) {
      return false;
    }

    let shouldShow = false;

    for (const enrol of eligibleEnrollments) {
      const batchDate = new Date(enrol.batch_date);

      // Fetch inauguration date for this batch
      const inaugurationDate = await fetchBatchInaugurationDate(enrol.category, enrol.program_id, enrol.batch_id);

      let deadlineDate;
      if (inaugurationDate) {
        // If inauguration date found, use it as deadline
        deadlineDate = new Date(inaugurationDate);
        console.log(`Batch ${enrol.batch_id}: Using inauguration date ${inaugurationDate}`);
      } else {
        // If no inauguration date, use batch_date as deadline
        deadlineDate = new Date(batchDate);
        console.log(`Batch ${enrol.batch_id}: Using batch date ${enrol.batch_date}`);
      }

      // Add 7 days buffer after batch inauguration/start date
      deadlineDate.setDate(deadlineDate.getDate() + 7);

      // Check if current date is before deadline
      if (currentDate <= deadlineDate) {
        shouldShow = true;
        break; // Found at least one valid batch
      }
    }

    if (!shouldShow) {
      return false;
    }

    try {
      // Check backend skip count
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/profile/fetchExpectationSkipStatus`,
        { user_id: userId }
      );

      if (response.data.status === 200) {
        console.log(response)
        //  const student_expectation_status = Number(response.data.data.student_expectation_status) || 0;
        const backendSkipCount = Number(response.data.data.expectation_skip_status) || 0;
        const student_expectation_status = Number(response.data.data.student_expectation_status) || 0;
        setShowExpectationButton(student_expectation_status === 0);
        console.log(student_expectation_status)
        // Don't show if backend skip count >= 3
        // Check localStorage skip count
        const localSkipCount = parseInt(localStorage.getItem('expectation_skip_count') || '0');
        if (localSkipCount > 0) {
          return false;
        }


        if (backendSkipCount >= 3 || student_expectation_status == 1) {
          return false;
        }

        // Check if expectations are already filled
        if (tab !== 'my-applications') {
          const detailsResponse = await axios.post(
            `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/profile/fetchIITKUserDetails`,
            { user_id: userId }
          );

          if (detailsResponse.data.status === 200) {
            const userData = detailsResponse.data.data[0];

            // Don't show if all expectation fields are filled
            if (userData.expectations && userData.challenges && userData.expert_focus && userData.consent === '1') {
              return false;
            }
          }
        }
      }
    } catch (error) {
      console.error('Error checking expectations modal status:', error);
    }

    return true;
  };

  useEffect(() => {
    const checkExpectationsModal = async () => {
      const userId = localStorage.getItem('user_id');

      if (userId && enrolledPrograms.length > 0) {
        const shouldShow = await shouldShowExpectationsModal(userId, enrolledPrograms);
        setExpectationsModalOpen(shouldShow);
      }
    };

    if (!loading && enrolledPrograms.length > 0 && tab !== 'my-applications') {
      // Only trigger for active or under_review — skip 'registered' users
      const hasEligibleStatus = enrolledPrograms.some(
        enrol => enrol.status === 'active' || enrol.status === 'under_review'
      );
      if (hasEligibleStatus) {
        checkExpectationsModal();
      }
    }
  }, [loading, enrolledPrograms]);

  const handleExpectationButtonClick = () => {
    setExpecationsUpdateCount(false);
    setExpectationsModalOpen(true);
  };

  useEffect(() => {
    const fetchToken = async () => {
      // Guard: run the full token verification + enrollment fetch only once.
      // Without this, switching tabs (tab is in the deps array) would re-fire
      // verifyToken and overwrite localStorage.status, breaking the sidebar.
      if (hasFetchedRef.current) {
        return;
      }
      hasFetchedRef.current = true;
      // console.log("called")
      const token = document.cookie.replace(
        /(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/,
        "$1"
      );
      if (token) {
        const options = {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            authorization: token,
            "Page-Index": generateApiKey(), // header key for API authentication
          },
        };
        const sendData = {};
        console.log(options, "options");
        await axios
          .post(
            `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/verifyToken/token`,
            sendData,
            options
            // header key for API authentication
            // { withCredentials: true }
          )
          .then((result) => {
            console.log(result, "result");
            localStorage.setItem("modalState", true);
            if (result.data.status == 200) {
              const user_data = result.data.data;
              if (user_data.user_role === 7) {
                setIsFaculty(true);
              }
              if (user_data.count > 1) {
                console.log(user_data.count, "enrol count");
                window.localStorage.setItem("user_id", user_data.user_id);
                if (window.clarity && typeof window.clarity === "function") {
                  // window.clarity("set", "user_id", user_data?.user_id);
                  // window.clarity("set", "app", "lms");
                  window.clarity("identify", String(user_data?.user_id));
                  window.clarity("set", "uid", String(user_data?.user_id));
                }
                window.localStorage.setItem("count", user_data.count);
                window.localStorage.setItem("username", user_data.firstname);
                window.localStorage.setItem("lastname", user_data.userlastname);
                window.localStorage.setItem("email", user_data.email);
                window.localStorage.setItem("mobile", user_data.mobile);
                window.localStorage.setItem("dob", user_data.dob);
                window.localStorage.setItem("batch_id", user_data.batch_id);
                window.localStorage.setItem("term", user_data.term);
                // navigate(`/`);
                setLoading(false);
                LoaderOpen();
                const sendData = {
                  user_id: localStorage.getItem("user_id"),
                };
                // //console.log(auth)
                var user_id = localStorage.getItem("user_id");
                setUser(user_id);
                var enrooll = localStorage.getItem("count");
                setEnrooll(enrooll);
                // if (tab !== 'my-applications') {
                axios
                  .post(
                    `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/fetchenrolments`,
                    JSON.stringify(sendData),
                    options,
                    { withCredentials: true }
                  )
                  .then((result) => {
                    // setData(result.data);
                    setEnrolledPrograms(result.data);
                    LoaderClose();
                    const syncStatus = result.data.some((enrol) =>
                      studentDetailsSyncBatchIds.includes(enrol.batch_id)
                    );
                    // console.log(result.data)
                    // const expectationStatus = result.data.some((enrol) =>
                    //   expectationDetailsBatchIds.includes(enrol.batch_id)
                    // );
                    // 15 Oct 2025
                    const expectationStatus = result.data.some(enrol => {
                      const batchDate = new Date(enrol.batch_date);
                      return batchDate > currentDate;
                    });
                    console.log("sync status" + syncStatus);
                    if (syncStatus || expectationStatus) {
                      // Only redirect to studentDetails for active/under_review — skip 'registered'
                      const hasEligibleStatus = result.data.some(
                        enrol => enrol.status === 'active' || enrol.status === 'under_review'
                      );
                      if (tab !== 'my-applications' && hasEligibleStatus) {
                        axios
                          .post(
                            `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/profile/fetchIITKUserDetails`,
                            {
                              user_id: user_data.user_id,
                            }
                          )
                          .then((res) => {
                            // console.log(res, "seee")
                            if (res.data.status == 200) {
                              const {
                                address1,
                                city,
                                country,
                                current_organization,
                                dob,
                                gender,
                                mobile,
                                pincode,
                                qualification,
                                university,
                                industry,
                                designation,
                                work_ex,
                                expectations, challenges, expert_focus, consent
                              } = res.data.data[0];
                              if (
                                !(
                                  address1 &&
                                  city &&
                                  country &&
                                  current_organization &&
                                  dob &&
                                  gender &&
                                  mobile &&
                                  pincode &&
                                  qualification &&
                                  university &&
                                  industry &&
                                  designation &&
                                  work_ex
                                )
                              ) {
                                // studentDetailsSyncBatchIds

                                navigate(`/studentDetails?expectations=${expectationStatus ? 'true' : 'false'}`);

                              }
                            }
                          });
                      }
                    }
                  });
                // } else {
                //   LoaderClose();
                // }
                // if (user_data.program_id == 74) {

                // }
              } else if (user_data.count == "1" || user_data.count == "0") {
                console.log(user_data, "user_data count 1");
                window.localStorage.setItem("user_id", user_data.user_id);
                if (window.clarity && typeof window.clarity === "function") {
                  // window.clarity("set", "user_id", user_data?.user_id);
                  // window.clarity("set", "app", "lms");
                  window.clarity("identify", String(user_data?.user_id));
                  window.clarity("set", "uid", String(user_data?.user_id));
                }
                // Set all properties from user_data to localStorage automatically
                /* Object.keys(user_data).forEach((key) => {
                 const value = user_data[key];
                 if (value !== null && value !== undefined && typeof value !== "object" && typeof value !== "function") {
                   window.localStorage.setItem(key, String(value));
                 }
               }); */

                window.localStorage.setItem("enrol_id", user_data.enrol_id);
                window.localStorage.setItem("category", user_data.category);
                window.localStorage.setItem("count", user_data.count);
                window.localStorage.setItem("username", user_data.firstname);
                window.localStorage.setItem("lastname", user_data.userlastname);
                window.localStorage.setItem("email", user_data.email);
                window.localStorage.setItem("mobile", user_data.mobile);
                window.localStorage.setItem("user_role", user_data.user_role);
                window.localStorage.setItem("program_id", user_data.program_id);
                window.localStorage.setItem("dob", user_data.dob);
                window.localStorage.setItem("batch_id", user_data.batch_id);
                window.localStorage.setItem("term", user_data.term);
                // Guard: only write status if it's a real value from the token API
                // user_data.status can be undefined for count==1 users, which would break the sidebar
                if (user_data.status !== undefined && user_data.status !== null) {
                  window.localStorage.setItem("status", user_data.status);
                }

                window.localStorage.setItem("user_expectations", user_data.user_expectations);
                window.localStorage.setItem("user_challenges", user_data.user_challenges);
                window.localStorage.setItem("user_expert_focus", user_data.user_expert_focus);
                window.localStorage.setItem("user_consent", user_data.user_consent);
                const sendData = {
                  user_id: localStorage.getItem("user_id"),
                };
                axios
                  .post(
                    `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/fetchenrolments`,
                    JSON.stringify(sendData),
                    options,
                    { withCredentials: true }
                  )
                  .then((result) => {
                    // console.log(result);
                    window.localStorage.setItem(
                      "program_name",
                      result.data[0].program_name
                    );
                    // setData(result.data);
                    setEnrolledPrograms(result.data);
                    LoaderClose();

                    const syncStatus = studentDetailsSyncBatchIds.includes(
                      result?.data[0]?.batch_id
                    );

                    // const expectationStatus = result.data.some((enrol) =>
                    //   expectationDetailsBatchIds.includes(enrol.batch_id)
                    // );

                    const expectationStatus = result.data.some(enrol => {
                      const batchDate = new Date(enrol.batch_date);
                      return batchDate > currentDate;
                    });

                    console.log("sync status " + syncStatus);
                    if (syncStatus || expectationStatus) {
                      // Only redirect to studentDetails for active/under_review — skip 'registered'
                      const hasEligibleStatus = result.data.some(
                        enrol => enrol.status === 'active' || enrol.status === 'under_review'
                      );
                      if (tab !== 'my-applications' && hasEligibleStatus) {
                        axios
                          .post(
                            `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/profile/fetchIITKUserDetails`,
                            {
                              user_id: user_data.user_id,
                            }
                          )
                          .then((res) => {
                            console.log(res, "seee");
                            if (res.data.status == 200) {
                              const {
                                address1,
                                city,
                                country,
                                current_organization,
                                dob,
                                gender,
                                mobile,
                                pincode,
                                qualification,
                                university,
                                industry,
                                designation,
                                work_ex,
                                expectations, challenges, expert_focus, consent
                              } = res.data.data[0];
                              if (
                                address1 &&
                                city &&
                                country &&
                                current_organization &&
                                dob &&
                                gender &&
                                mobile &&
                                pincode &&
                                qualification &&
                                university &&
                                industry &&
                                designation &&
                                work_ex
                              ) {
                                // navigate(`/Dashboard`);
                              } else {
                                navigate(`/studentDetails?expectations=${expectationStatus ? 'true' : 'false'}`);
                              }
                            }
                          });
                      }
                    }
                  });

                setLoading(false);
                // if (user_data.program_id == 74) {
              }
              // }
            } else {
              // console.log(result.data.messaage)
              // alert(result.data.messaage)
              localStorage.clear();
              Swal.fire({
                title: "Timeout",
                text: "Your Session has been expired please relogin",
                icon: "info",
                confirmButtonText: "Ok",
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.href = "https://accredian.com";
                }
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              title: "Timeout",
              text: "Your Session has been expired please relogin",
              icon: "info",
              confirmButtonText: "Ok",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "https://accredian.com";
              }
            });
            localStorage.clear();
          });
      } else {
        // window.location.href = 'http://localhost:3000https://frontend-project2.accredian.com/login';
        // console.log("no token")
        localStorage.clear();
        Swal.fire({
          title: "Timeout",
          text: "Your Session has been expired please relogin",
          icon: "info",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "https://accredian.com";
          }
        });
      }
    };
    fetchToken();
  }, [tab]);

  const handleClickOpen = (item) => {
    const {
      enrol_id,
      category,
      program_id,
      term,
      program_name,
      program_code,
      batch_id,
      batch_date,
      status,
      is_completed,
      inclusion_link
    } = item;
    window.localStorage.removeItem("step"); // or keep as is
    window.localStorage.removeItem("step_status");
    let matchedStep = null;
    let stepStatus = null;
    let matchedUniversity = null;

    let iitg_steps = {
      1: "Applicant Details",
      2: "Application Fee",
      3: "Assessment",
      4: "Program Enrolment",
      5: "Upload Documents",
      6: "Offer Letter Acceptance",
    };

    let iimv_steps = {
      1: "Applicant Details",
      2: "Application Fee",
      3: "Provisional Letter",
      4: "Program Enrolment",
      5: "Offer Letter Acceptance",
    };

    appData.forEach((section) => {
      section.applications.forEach((app) => {
        if (
          app.enrol_id === enrol_id &&
          app.category === category &&
          app.program_id === program_id &&
          app.batch_id === batch_id
        ) {
          matchedStep = app.step;
          stepStatus = app.step_status;
          matchedUniversity = app.university;
        }
      });
    });

    if (matchedStep !== null) {
      if (matchedUniversity === "iitg") {
        matchedStep = iitg_steps[matchedStep] || null;
      } else if (matchedUniversity === "iimv") {
        matchedStep = iimv_steps[matchedStep] || null;
      }
    }

    //console.log(enrol_id, category);
    console.log("Status set from my account " + status)
    // Guard: only update status if it's a real value
    if (status !== undefined && status !== null) {
      window.localStorage.setItem("status", status);
    }

    window.localStorage.setItem("enrol_id", enrol_id);
    window.localStorage.setItem("category", category);
    window.localStorage.setItem("program_id", program_id);
    window.localStorage.setItem("term", term);
    window.localStorage.setItem("program_name", program_name);
    window.localStorage.setItem("program_code", program_code);
    window.localStorage.setItem("batch_id", batch_id);
    window.localStorage.setItem("batch", batch_date);
    window.localStorage.setItem("is_completed", is_completed);
    window.localStorage.setItem("inclusion_link", inclusion_link);
    window.localStorage.setItem("university", item.university);
    // ✅ store the matched step
    if (matchedStep !== null) {
      window.localStorage.setItem("step", matchedStep);
      window.localStorage.setItem("step_status", stepStatus);
    } else {
      window.localStorage.removeItem("step"); // or keep as is
      window.localStorage.removeItem("step_status");
    }

    navigate(`/Dashboard`);
  };
  const LoaderOpen = () => {
    setOpen(true);
  };
  const LoaderClose = () => {
    setOpen(false);
  };

  const { data, isFetching: isFetchingApplication } = useQuery({
    queryFn: ({ user_id }) => fetchApplicationsService({ user_id }),
    queryKey: ["applications", tab],
    enabled: localStorage.getItem("user_id") != null,
  });

  const { data: categoriesData, isFetching: isFetchingCategories } = useQuery({
    queryFn: () => fetchCategoriesService(),
    queryKey: ["program"],
    enabled: localStorage.getItem("user_id") !== null,
  });

  // Fetch acknowledgment status
  const {
    data: acknowledgmentData,
    isFetching: isFetchingAcknowledgment,
  } = useQuery({
    queryFn: () => fetchAcknowledgmentStatusService(),
    queryKey: ["acknowledgment"],
    enabled: tab !== "my-applications",
  });

  useEffect(() => {
    if (acknowledgmentData && acknowledgmentData?.security_status === 0) {
      setAcknowledgementModalOpen(true);
    } else {
      setAcknowledgementModalOpen(false);
    }
  }, [acknowledgmentData]);


  useEffect(() => {
    // Guard: only run if we have all required data
    console.log("Enhancing programs with data:", {
      applications: data?.applications,
      categories: categoriesData,
      enrolledPrograms
    });
    if (!data?.applications || !categoriesData || !enrolledPrograms.length) {
      console.log('Missing data');
      return;
    }
    setIsEnhancing(true);
    console.log('Enhancing programs with university data');

    const enhanced = enrolledPrograms.map((program) => {
      const appMatch = data.applications.find(
        (app) => app.program_id === program.program_id &&
          app.batch_id === program.batch_id
      );

      if (appMatch) {
        return {
          ...program,
          universityFullName: UNIVERSITY_FULL_NAMES[appMatch.university] || 'Independent Program',
          programcode: appMatch.program_code || 'N/A',
          university: appMatch.university,
          category_name: appMatch.category_name,
          category_image_url: appMatch.category_image_url
        };
      }

      return {
        ...program,
        universityFullName: UNIVERSITY_FULL_NAMES[program.university] || 'Independent Program',
        programcode: program.program_code || 'N/A',
        category_name: program.category_name || 'N/A',
        category_image_url: program.category_image_url
      };
    });

    setEnhancedPrograms(enhanced); // Only set enhanced data
    // setProgramData(enhanced);

    // Also update application data
    const grouped = groupApplicationsByStatus(data.applications, categoriesData);
    const updatedAppData = [...APPLICATION_DATA];
    updatedAppData[0].applications = grouped?.ongoing;
    updatedAppData[1].applications = grouped?.completed;

    if (grouped?.ongoing?.length || grouped?.completed?.length) {
      setIsUserHasApplications(true);
    }
    setAppData(updatedAppData);
    setIsEnhancing(false);

  }, [data?.applications, categoriesData, enrolledPrograms]);


  useEffect(() => {
    setSideTab(tabParam);
  }, [tabParam]);

  useEffect(() => {
    if (isFaculty) {
      navigate("/dashboard");
    }
  }, [isFaculty, navigate]);

  const handleTabClick = (tab) => {
    setExpanded(false);
    setSideTab(tab);
    navigate(`?tab=${tab.toLowerCase().replace(/\s+/g, "-")}`);
  };

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "50% auto",
          }}
        >
          {" "}
          <CircularProgress color="inherit" />
          Loading....
        </Box>
      ) : (
        <>
          <Box>
            {/* <Dashborednav /> */}
            <Layout>
              <div className="w-full xl:px-12 px-0 lg:px-4 py-0 min-h-[80vh] flex justify-center font-circular">
                <div className="w-full max-w-[85rem] flex gap-2 lg:gap-6 lg:flex-row flex-col items-start">
                  {/* Main Content Area */}
                  <div className="flex-1 lg:px-0 px-4">
                    {sideTab.toLocaleLowerCase() === "my-applications" ? (
                      <>
                        <div className="w-full flex justify-between items-center">
                          <h1 className="text-lg md:text-2xl font-semibold">
                            My Applications
                          </h1>
                          <button
                            onClick={() => setIsExploreModalOpen(true)}
                            className="flex items-center gap-1 px-4 py-2 text-universal hover:bg-blue-200  rounded-lg"
                          >
                            {/* <div className="w-4 md:w-5 h-4 md:h-5 flex-shrink-0">
                              <GoPlus className="w-full h-full" />
                            </div> */}
                            {/* <h1 className="font-medium text-sm md:text-base">
                              Start new Application
                            </h1> */}
                          </button>
                        </div>
                        <div className="mt-4">
                          {isEnhancing || isFetchingApplication || isFetchingCategories ? (
                            <div className="w-full h-[50vh] flex items-center justify-center">
                              <div className="flex flex-col items-center gap-5">
                                <CircularProgress color="inherit" />
                                <h1 className="text-lg font-medium">
                                  Please wait while we are fetching your applications...
                                </h1>
                              </div>
                            </div>
                          ) : isUserHasApplications ? (
                            appData.map((tab, index) => {
                              console.log(tab);
                              return (
                                <ApplicationAccord
                                  isModalOpen={isExploreModalOpen}
                                  setIsModalOpen={setIsExploreModalOpen}
                                  handleClickOpen={handleClickOpen}
                                  expanded={expanded}
                                  setExpanded={setExpanded}
                                  tab={tab}
                                  key={tab.id}
                                />
                              );
                            })
                          ) : (
                            <NoEnrollmentsState variant="myApplications" />
                          )}
                        </div>
                      </>
                    ) : enhancedPrograms.length ? (
                      <>
                        <h1 className="text-2xl font-semibold">My Courses</h1>
                        <div className="grid grid-cols-1 md:grid-cols-3 mt-6 gap-5 lg:gap-6 pb-6">
                          {enhancedPrograms.map((item, index) => (
                            <ProgramCard
                              key={index}
                              item={item}
                              handleClickOpen={handleClickOpen}
                            />
                          ))}
                        </div>
                      </>
                    ) : (
                      <div className="w-full flex flex-col gap-6">
                        <div className="w-full p-8 bg-white border drop-shadow-sm rounded-xl flex gap-2">
                          <div className="w-4 md:w-7 h-4 md:h-7 flex-shrink-0 mt-0.5">
                            <IoMdInformationCircleOutline className="w-full h-full text-universal" />
                          </div>
                          <h1 className="text-base md:text-lg font-medium">
                            It appears that you are not currently enrolled in any
                            program. Please either complete your application if it is
                            in progress or select a course from the options below to
                            proceed.
                          </h1>
                        </div>
                        <ExploreProgramsCard perks={[]} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Layout>
            {/* Floating Action Button */}
            {showExpectationButton && sideTab.toLowerCase() === "my-courses" && (
              <>
                <Tooltip
                  title="Student Expectations Form"
                  enterTouchDelay={0}
                  leaveTouchDelay={3000}
                  arrow
                >
                  <Fab
                    aria-label="fill student expectations"
                    onClick={handleExpectationButtonClick}
                    sx={{
                      display: { xs: "flex", md: "none" },
                      position: "fixed",
                      bottom: (theme) => theme.spacing(3),
                      right: (theme) => theme.spacing(3),
                      zIndex: 1000,
                      backgroundColor: "#1A73E8",
                      color: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#1557b0",
                      },
                    }}
                  >
                    <MdOutlineAssignment size={20} />
                  </Fab>
                </Tooltip>

                <Fab
                  variant="extended"
                  aria-label="fill student expectations"
                  onClick={handleExpectationButtonClick}
                  sx={{
                    display: { xs: "none", md: "flex" },
                    position: "fixed",
                    bottom: (theme) => theme.spacing(3),
                    right: (theme) => theme.spacing(3),
                    zIndex: 1000,
                    textTransform: "none",
                    paddingX: 3,
                    paddingY: 1.5,
                    fontSize: "16px",
                    fontWeight: 500,
                    backgroundColor: "#1A73E8",
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#1557b0",
                    },
                  }}
                >
                  <MdOutlineAssignment size={20} style={{ marginRight: "8px" }} />
                  Student Expectations Form
                </Fab>
              </>
            )}
          </Box>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open || isFetchingAcknowledgment}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <ExploreProgramsModal
            open={isExploreModalOpen}
            setOpen={setIsExploreModalOpen}
          />
          <ExpectationsModal
            isOpen={expectationsModalOpen}
            updateExpectationsCount={updateExpectationsCount}
            onClose={() => setExpectationsModalOpen(false)}
            userId={localStorage.getItem('user_id')}
          />
          <SecurityAdvisoryModal open={acknowledgementModalOpen} setOpen={setAcknowledgementModalOpen} />
        </>

      )}
    </>
  )
};

export default Myaccount;
